module.exports = __webpack_public_path__ + "img/logo.169a4208.png";